import { useForm, useWatch } from "react-hook-form";
import type { NameInputForm } from "@components/NameInput";
import type { PhoneNumberInputForm } from "@components/PhoneNumberInput";
import { getReservationDateFromOptionValue } from "./_reservationDateOptionValue";

export type RequestReservationInputForm = {
  date?: string;
  matchId?: string;
  supportingTeamId?: string;
  comesAt?: string;
  personNum?: string;
  frameId?: string;
  userMessage?: string;
} & NameInputForm &
  PhoneNumberInputForm;

const useRequestReservationForm = () => {
  const methods = useForm<RequestReservationInputForm>({
    mode: "onChange",
    shouldUnregister: false,
  });
  const { getValues, trigger, control } = methods;

  const selectedDateOptionValue = useWatch({
    control,
    name: "date",
  });
  const selectedDate = getReservationDateFromOptionValue(
    selectedDateOptionValue
  );

  const selectedMatchId = useWatch({
    control,
    name: "matchId",
  });

  const selectedSupportingTeamId = useWatch({
    control,
    name: "supportingTeamId",
  });

  const selectedFrameId = useWatch({
    control,
    name: "frameId",
  });

  const selectedPersonNum = useWatch({
    control,
    name: "personNum",
  });

  const inputtedUserMessage = useWatch({
    control,
    name: "userMessage",
  });

  const triggerName = () => {
    const values = getValues([
      "firstName",
      "firstNameKana",
      "lastName",
      "lastNameKana",
    ]);
    if (values.every((v) => v)) {
      trigger(["firstName", "firstNameKana", "lastName", "lastNameKana"]);
    }
  };

  return {
    methods,
    selectedDateOptionValue,
    selectedDate,
    selectedMatchId,
    selectedSupportingTeamId,
    selectedFrameId,
    selectedPersonNum,
    inputtedUserMessage,
    triggerName,
  };
};
export default useRequestReservationForm;
